<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import checkbox from '@/components/Main/Inputs/checkbox'
import {find} from "lodash";
import ContactPhone from "./ContactPhone.vue";
import ContactEmail from "./ContactEmail.vue";

export default {
  name: "ContactVendor",
  components: {CustomSelect, checkbox, ContactPhone, ContactEmail},
  props: {
    contact: {
      type: Object,
      default: () => ({})
    },
    contactIndex: {
      type: Number,
      default: 0,
    },
    lastContactIndex: {
      type: Number,
      default: 0,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    positionsList: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    positionTitle() {
      const position =  find(this.positionsList, elem => elem.id === this.contact.position) || {};
      return position ? position.name : ''
    },
  },
  methods: {
    setSelectValue(item, entity){
      this.$set(this.contact, entity, item.id)
    },
    removeContact() {
      this.$emit('removeContact', this.contactIndex);
    },
    addContact() {
      this.$emit('addContact');
    },
    openPhoneSettings() {
      this.openPhoneSetting = true;
    },
    closePhoneSettings() {
      this.openPhoneSetting = false;
    },
    setInputValue(value, entity) {
      this.$set(this.contact, entity, value)
    },
    removePhone(phoneIndex) {
      this.$emit('removePhoneContact', phoneIndex, this.contactIndex);
    },
    addPhone() {
      this.$emit('addPhoneContact', this.contactIndex);
    },
    removeEmail(emailIndex) {
      this.$emit('removeEmailContact', emailIndex, this.contactIndex);
    },
    addEmail() {
      this.$emit('addEmailContact', this.contactIndex);
    },
  }

}
</script>

<template>
  <div class="department">

    <div class="department__item">
      <label class="department__label">Contact person</label>
      <div class="department__body is-first ">
        <template v-if="editable">
          <input
            :value="contact.contactPerson"
            type="text"
            class="department__input"
            autocomplete="off"
            @input="(e) => setInputValue(e.target.value, 'contactPerson')"
          >
        </template>
        <template v-else>
          <div class="department__text">
            {{contact.contactPerson}}
          </div>
        </template>
      </div>
      <template v-if="editable">
        <div
          v-if="contactIndex !== lastContactIndex"
          class="department__item-action"
          @click.stop="removeContact"
        >
          <i class="icon-minus department__minus-icon"/>
        </div>
        <div
          v-if="contactIndex === lastContactIndex"
          class="department__item-action"
          @click.stop="addContact"
        >
          <i class="icon-cross department__add-icon"/>
        </div>
      </template>
    </div>

    <div
      v-if="editable"
      class="department__item"
    >
       <label class="department__label">Department</label>
       <div class="department__body">
           <input
             :value="contact.department"
             type="text"
             class="department__input"
             autocomplete="off"
             @input="(e) => setInputValue(e.target.value, 'department')"
           >
          </div>
       </div>
    <div
      v-if="!editable && contact.department"
      class="department__item"
    >
      <label class="department__label">Department</label>
      <div class="department__body is-show">
        <div class="department__text">
          {{contact.department}}
        </div>
      </div>
    </div>

    <div
      v-if="editable"
      class="department__item"
    >
      <label class="department__label">Position</label>
      <div class="department__body">
        <custom-select
          class="department__select"
          :list="positionsList"
          :default-val="positionTitle"
          @setValue="(value) => setSelectValue(value, 'position')"
        />
      </div>
    </div>
    <div
      v-if="!editable && positionTitle"
      class="department__item"
    >
      <label class="department__label">Position</label>
      <div class="department__body is-show">
        <div class="department__text">
          {{ positionTitle }}
        </div>
      </div>
    </div>

    <ContactPhone
      v-for="(phone, index) in contact.phone"
      :key="contact.id + index"
      :phone="phone"
      :phoneIndex="index"
      :lastPhoneIndex="contact.phone.length - 1"
      :editable="editable"
      @addPhone="addPhone"
      @removePhone="removePhone"
    />

    <ContactEmail
      v-for="(email, index) in contact.email"
      :key="email.id"
      :email="email"
      :emailIndex="index"
      :lastEmailIndex="contact.email.length - 1"
      :editable="editable"
      @addEmail="addEmail"
      @removeEmail="removeEmail"
    />

  </div>

</template>

<style scoped lang="scss">
@import "../../../../../../sass/variables";

.department {
  border: 1px dashed $color-seashell;
  border-radius: 5px;
  margin: 9px 25px 9px 15px;
  transition: 0.3s;
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    column-gap: 12px;
  }

  &__label {
    align-self: flex-start;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    color: $color-denim;
    min-width: 168px;
  }

  &__body {
    flex: 1 1 auto;
    min-height: 32px;
    padding-right: 42px;

    &.is-first,
    &.is-show {
      padding-right: 0;
    }
  }

  &__item-action {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $color-seashell;
    box-sizing: border-box;
    border-radius: 5px;
    min-width: 30px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  &__add-icon {
    color: $color-denim;
    transform: rotate(45deg);
  }

  &__minus-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2px;
    color: $color-accent;
  }

  &__input {
    width: 100%;
    height: 30px;
    padding: 10px 30px 10px 7px;
    border: 1px solid $color-seashell;
    border-radius: 5px;
  }

  &__select {
    height: 32px;
  }

  &__text {
    text-align: right;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactServiceProvider/ContactVendor.vue